module.exports = __webpack_public_path__ + "static/img/case4.445d06e3.jpg";